import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import {Col, Input, InputProps, Row} from 'antd';
import styles from './styles';

type CustomInputInterface = InputProps & {className?: string};

const CustomInput = (props: CustomInputInterface) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {className, ...restProps} = props;

  return <Input className={classNames(classes.input, className)} {...restProps} />;
};

export default CustomInput;
